export default "__VITE_ASSET__BalIIMQC__"